<p-card>
  <p-accordion>
    @for (location of locationService.locations; track location.id) {
      <p-accordion-panel [value]="location.id">
        <p-accordion-header>{{location.city}}</p-accordion-header>
        <p-accordion-content>
          <app-location-schedule [locationId]="location.id"></app-location-schedule>
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
</p-card>
